import api from "./api"

export const listHistory = async (
  order_by = "opht_dcreated",
  target_ctype,
  target_nid,
  search,
  page = 1,
  per_page = 15,
  order = "DESC",
) => {
  return await api.get(
    `/op-panel/history?target_ctype=${target_ctype}&order_by=${
      order_by + "&order=" + order
    }&target_nid=${target_nid}&page=${page}&per_page=${per_page}${search ? search : ""}`,
  )
}

